export default __webpack_public_path__ + "static/media/menu21.857e03f2.svg";